<template>
  <div>
    <img class="d-flex justify-center seedling-img" src="seedling.png" />

    <div class="title-words d-flex justify-center">
      Lineage Independence Trust Program
    </div>

    <div class="d-flex justify-center">
      <v-sheet class="input-form">
        <v-row class="d-flex justify-center">
          <div class="login-word">login</div>
        </v-row>
        <v-row>
          <div class="label">email</div>
        </v-row>
        <v-row>
          <v-text-field
            id="js-email"
            v-model="email"
            filled
            single-line
            dense
            outlined
            class="ma-4 input-field"
            background-color="#f2eae2"
            color="#35606f"
          ></v-text-field>
        </v-row>
        <v-row>
          <div class="label">password</div>
        </v-row>
        <v-row>
          <v-text-field
            v-model="password"
            class="ma-4 input-field invalidClass"
            filled
            single-line
            dense
            outlined
            background-color="#f2eae2"
            color="#35606f"
            :append-icon="showPass ? 'visibility' : 'visibility_off'"
            id="js-password"
            :type="showPass ? 'text' : 'password'"
            @click:append="showPass = !showPass"
            :error-messages="errorMessage"
            @keyup.enter="clicked"
          ></v-text-field>
        </v-row>
        <v-row class="d-flex justify-center">
          <v-btn
            id="js-login"
            class="login-btn default-action-btn"
            @click="clicked"
          >
            Login
          </v-btn>
        </v-row>
        <v-row class="d-flex justify-center">
          <router-link
            id="js-forgot-password"
            :to="{ name: 'forgotPassword' }"
            class="forgot-link"
            >forgot password</router-link
          >
        </v-row>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import EventBus from "@/lib/eventBus"
import { StatusAPI, UsersAPI } from "@/lib/api"
import { apiConfig } from "@/lib/config"
import User from "@/lib/user"

export default {
  data: function() {
    return {
      email: "",
      password: "",
      showPass: false,
      errorMessage: ""
    }
  },
  created: function() {
    StatusAPI.get()
  },
  methods: {
    setDefaultUserMode() {
      if (User.getUserType() === 1) {
        this.$store.commit("globals/setUserMode", "MANAGE")
      } else if (User.getUserType() === 2) {
        this.$store.commit("globals/setUserMode", "MENTOR")
      } else if (User.getUserType() === 4) {
        this.$store.commit("globals/setUserMode", "MENTEE")
      }
    },
    clicked: function() {
      // let promise = Notification.requestPermission()
      UsersAPI.login(this.email, this.password).then(
        response => {
          let token = response.headers["authorization"].replace("Bearer ", "")
          apiConfig.headers.Authorization = `Bearer ${token}`
          User.setToken(token)
          this.$toasted.clear()
          this.setDefaultUserMode()
          this.$toasted.success(
            `Welcome back ${response.data.first_name} ${
              response.data.last_name
            }`,
            {
              icon: "verified_user",
              position: "top-center",
              duration: 2200,
              fullWidth: false,
              theme: "bubble"
            }
          )
          EventBus.$emit("login")
        },
        error => {
          console.log(error)
          this.errorMessage = "email and/or password are not correct"
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

$section-width: 300px;

.input-form {
  width: $section-width;
  margin-top: 55px;
  padding: 50px 30px 0px 30px;
  border-radius: 25px;
  @media only screen and (max-width: 400px) {
    margin-top: 25px;
  }
}

.label {
  color: $dark-blue;
  font-weight: 800;
  margin: 0px 0px -15px 20px;
}

.seedling-img {
  max-width: 200px;
  margin: 20px auto 0px auto;
}
.login-btn {
  width: 175px;
  margin-top: 10px;
}

.login-word {
  font-style: italic;
  color: $light-yellow;
  font-size: 1.8em;
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 20px;
}

.title-words {
  font-style: italic;
  color: $dark-yellow;
  font-size: 1.8em;
  text-transform: uppercase;
  font-weight: 500;
  padding-top: 40px;
  @media only screen and (max-width: 600px) {
    font-size: 1.2em;
    padding-top: 20px;
  }
  @media only screen and (max-width: 400px) {
    font-size: 0.8em;
  }
}

.forgot-link {
  margin-top: 55px;
}
a.forgot-link {
  text-decoration: none !important;
  color: $dark-blue !important;
}
</style>
